import { ConfigProvider, Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import { CustomTabItemAtom } from "~/components/Atoms/CustomTabItemAtom/CustomTabItemAtom";

type itemProps = {
  label: React.ComponentProps<typeof CustomTabItemAtom>["title"];
  key: string;
  content: string | JSX.Element;
};

type Props = {
  items: itemProps[];
  style?: React.CSSProperties;
  tabBarStyle?: React.CSSProperties;
  defaultActiveKey?: string;
  defaultContent?: string | JSX.Element;
  setActiveTabKey?: (key: string) => void;
};

export const TabBar = (props: Props) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            inkBarColor: "#004BFF",
            itemActiveColor: "#004BFF",
            itemSelectedColor: "#004BFF",
            horizontalItemPadding: "0px",
          },
        },
      }}
    >
      <Tabs
        defaultActiveKey={props.defaultActiveKey ?? props.items[0]?.key}
        style={
          props.style ?? {
            width: "100%",
          }
        }
        onChange={(key) => {
          props.setActiveTabKey?.(key);
        }}
        centered
        tabBarGutter={0}
        tabBarStyle={{
          ...props.tabBarStyle,
        }}
      >
        {props.items.map((item) => (
          <TabPane
            tab={<CustomTabItemAtom title={item.label} />}
            key={item.key}
          >
            {props.defaultContent ?? null}
            {item.content}
          </TabPane>
        ))}
      </Tabs>
    </ConfigProvider>
  );
};
